import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ReBaseData, getToS } from '../../../shared/utils/re-base-data';
import { TRACKING } from '../../enums/trackingParts.enum';
import { TrackingService } from '../../services/tracking.service';
import { LanguageService } from '../../services/language.service';

@Component({
    selector: 'bdo-terms-of-service',
    templateUrl: './terms-of-service.component.html',
    styleUrls: ['./terms-of-service.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class TermsOfServiceComponent implements OnInit {
  protected reBaseData = ReBaseData;
  protected tosHtml = getToS();

  constructor(
    private trackingService: TrackingService,
    public languageService: LanguageService
  ) { }

  ngOnInit() {
    this.trackingService.postTracking(TRACKING.LOCATION.TERMSOFSERVICE, TRACKING.ACTION.ENTER);
  }

}
